import type { RenamePlan, RenameTransformResult } from '@cli-types/core-engine/snapshots.js'
import { hasParseDiagnostics } from '@cli-utils/ts-morph.js'
import { Project } from 'ts-morph'
import { applyTextEdits } from './apply-text-edits.js'
import { buildEditsForSourceFile } from './build-edits-for-source-file.js'
import { collectPreviewChanges } from './collect-preview-changes.js'

const project = new Project({
  useInMemoryFileSystem: true,
  skipAddingFilesFromTsConfig: true
})

export function transformContentForRenamePlan(
  content: string,
  filePath: string,
  plan: RenamePlan,
  displayPath = filePath
): RenameTransformResult {
  if (plan.fields.length === 0 && plan.customCells.length === 0) {
    return {
      changed: false,
      content,
      parseFailed: false,
      previewChanges: []
    }
  }

  const sourceFile = project.createSourceFile(
    `rename-${displayPath.replace(/[^\w.-]+/g, '_')}`,
    content,
    { overwrite: true }
  )

  if (hasParseDiagnostics(sourceFile)) {
    return {
      changed: false,
      content,
      parseFailed: true,
      previewChanges: []
    }
  }

  const edits = buildEditsForSourceFile(sourceFile, filePath, plan)
  if (edits.length === 0) {
    return {
      changed: false,
      content,
      parseFailed: false,
      previewChanges: []
    }
  }

  const nextContent = applyTextEdits(content, edits)

  return {
    changed: nextContent !== content,
    content: nextContent,
    parseFailed: false,
    previewChanges: collectPreviewChanges(displayPath, content, nextContent)
  }
}
